import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import { servicesPt, servicesEng } from '../../translation/services';
import Card from '../../components/Card/Card';
import './ServicesSection.scss';

function ServicesSection() {
    let { languageIndex } = useContext(LanguageContext);
    let title = !languageIndex ? 'Portifólio' : 'Portfolio';
    let services = !languageIndex ? servicesPt : servicesEng;
    
    return (
        <>
        <h2 className='services-title'>{ title }</h2>

        <div className='servicos'>
            {services.map(service =>
                <Card
                icon={service.icon}
                title={service.title}
                text={service.text}
                />
            )}
        </div>
        </>
    )
}

export default ServicesSection;